import * as Sentry from '@sentry/core'
import { getUploadData } from './util'
import type { CsvOwner } from './uploadFile'
import http from '@paintscout/util/http'

export interface UploadOptions {
  /**
   * If provided(better be), folder will be setup accordingly /companyId/x
   */
  companyId: string

  /**
   * Temporary feature flag on s3 uploads
   */
  s3UploadFeatureEnabled: boolean

  /**
   * If provided, a tag of `doc-<id>` will be categorized under /companyId/doc-id/'x'
   * x = /{id} | /images/{id}
   */
  docId?: string

  /**
   * Type of csv upload we are doing
   */
  type?: string

  /**
   * Owner of newly created quote/contacts on csv upload
   */
  owner?: CsvOwner

  /**
   * Template used for upload
   */
  provider?: string

  tags?: string[]
}

export interface S3FileUploadData {
  size: number
  src: string
  s3PublicKey: string
  bucket: string
  format: string
  type: string
  pages?: number
  width?: number
  height?: number
}

export interface S3UrlComponents {
  key: string
  rawUrl: string
  bucket: string
}

/**
 * Upload file to correct key in images bucket
 */
export default async function s3UploadFile(file: File, url: string): Promise<S3FileUploadData> {
  const isCsv = file.type === 'text/csv' || file.name?.toLowerCase().endsWith('.csv')

  const config = {
    method: 'PUT',
    url,
    headers: {
      'Content-Type': file.type,
      // CSV uploads go to the temp bucket which has ACLs disabled
      // (BucketOwnerEnforced). Only include ACL for non-CSV uploads so it
      // matches what the server signed the URL with.
      ...(isCsv ? {} : { ACL: 'public-read' })
    },
    data: file
  }

  try {
    const res = await http(config)
    console.log('s3 uploadRes', res?.status)
  } catch (error) {
    console.log('error uploading file to s3', { url, file, error })
    Sentry.captureException(error)
    // Re-throw so callers don't proceed to trigger downstream processing
    // (e.g. the CSV handler lambda) against a file that never landed in S3.
    throw error
  }

  const uploadData = await getUploadData(file, url)

  return uploadData
}
